import {component, openWindow} from '@o2oa/o2core-js';
import style from './style.scope.css';
import template from './template.html';
import taskItem from '../base/taskItem.mjs';

const menuJson = [
    {
        "name": "文件列表",
        "icon": "o2icon-app",
        "component": "list"
    },
    {
        "name": "API文档",
        "icon": "o2icon-file",
        "open": "./public/api/DocEditor.html"
    }
];
export default component({
    template,
    style,
    bind: {"menu": menuJson},
    module:{
        components: {},
        selectedMenu(e, data){
            if (data.component){
                const item = e.currentTarget;
                item.getParent("div").querySelectorAll(".layout_menu_item").removeClass("mainColor_bg");
                item.addClass("mainColor_bg");
                this.loadComponent(data.component);
            }
            if (data.open) openWindow(data.open);
        },
        afterRender(){
            this.menuArea.querySelector('.layout_menu_item').click();

            // this.loadComponent("list");
        },
        async loadComponent(name) {
            let cmpt = this.components[name];
            if (!cmpt) cmpt = (await import(`./${name}.mjs`)).default;
            this.components[name] = await cmpt.render(this.appContent);
            this.components[name].contentApp = this;

            // this.createTaskItem(this.components[name], lp[name]);
            // this.setCurrentComponent(this.components[name]);
        },
        createDoc(){
            openWindow('./doc.html');
        }
    }
});
